import { createSlice } from "@reduxjs/toolkit";
import { CURRENT_STEP } from "../constants";

const modalNavSlice = createSlice({
  name: CURRENT_STEP,
  initialState: {
    clientStep: 1,
    resellerStep: 1,
  },
  reducers: {
    modalNavigation: (state, action) => {
      const data = {
        ...state,
        clientStep: action.payload,
      };
      return (state = data);
    },
    resellerModalNavigation: (state, action) => {
      const data = {
        ...state,
        resellerStep: action.payload,
      };
      return (state = data);
    },
  },
});

export const { modalNavigation, resellerModalNavigation } =
  modalNavSlice.actions;

export default modalNavSlice.reducer;
